<template>
  <div class="slider-container">
    <img
      :src="btn1Url"
      class="nav-button left"
      @click="slideRight"
      @mouseenter="changeUrl1(0)"
      @mouseleave="changeUrl1(1)"
      v-if="currentIndex !== 0"
    />
    <img
      :src="btn2Url"
      class="nav-button right"
      @click="slideLeft"
      @mouseenter="changeUrl2(0)"
      @mouseleave="changeUrl2(1)"
      v-if="currentIndex <=2 "
    />

    <div class="redTag"></div>
    <div class="slider-wrapper" ref="sliderWrapper">
      <div
        class="slider-content"
        :style="{ transform: `translateX(${offset}px)` }"
      >
        <div class="slider-item" v-for="(item, index) in items" :key="index">
          <img
            class="card"
            :src="`https://cdn-file.xiaojudai.cn/web/dist/customer/al${item}.png`"
          />
          {{ item }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [1, 2, 3, 4, 5, 6, 7], // 7张卡片
      currentIndex: 0,
      offset: 0,
      itemWidth: 360,
      visibleItems: 4, // 默认显示4项
      btn1Url: `https://cdn-file.xiaojudai.cn/web/dist/customer/leftIcon2.png`,
      btn2Url: `https://cdn-file.xiaojudai.cn/web/dist/customer/rightIcon2.png`,
    };
  },
  mounted() {
    this.calculateVisibleItems();
    window.addEventListener("resize", this.calculateVisibleItems);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateVisibleItems);
  },
  methods: {
    changeUrl1(e) {
      if (e === 0) {
        this.btn1Url = `https://cdn-file.xiaojudai.cn/web/dist/customer/leftIcon2.png`;
      } else {
        this.btn1Url = `https://cdn-file.xiaojudai.cn/web/dist/customer/leftIcon.png`;
      }
    },
    changeUrl2(e) {
      if (e === 0) {
        this.btn2Url = `https://cdn-file.xiaojudai.cn/web/dist/customer/rightIcon2.png`;
      } else {
        this.btn2Url = `https://cdn-file.xiaojudai.cn/web/dist/customer/rightIcon.png`;
      }
    },
    calculateVisibleItems() {
      // 可以根据容器宽度动态计算可见项数
      // 这里保持默认4项
      this.visibleItems = 4;
    },
    slideRight() {
      this.currentIndex--;
      if (this.currentIndex < 0) {
        this.currentIndex = this.items.length - 1;
      }
      this.updateOffset();
    },
    slideLeft() {
      this.currentIndex++;
      if (this.currentIndex >= this.items.length) {
        this.currentIndex = 0;
      }
      this.updateOffset();
    },
    updateOffset() {
      // 计算偏移量，使当前项显示在可视区域
      this.offset = -this.currentIndex * (this.itemWidth + 60);
    },
  },
};
</script>

<style scoped lang="scss">
//mobile414
@media screen and (max-width: 767px) {
  .slider-container:hover .nav-button{
    display: block;
  }
  .slider-container {
    display: flex;
    align-items: center;
    // width: 24.7778rem;
    height: 8.9259rem;
    margin: 0 auto;
    // margin-left: auto;
    position: relative;
    width: 100vw;

    .redTag {
      width: 2.6667rem;
      height: 2.6667rem;
      background: #c25e4d;
      border-radius: 0.4444rem 0 0.2222rem 0;
      position: absolute;
      left: -1.3333rem;
      bottom: -0.6667rem;
      left: calc(7vw - 70px);
    }
  }

  .slider-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-left: 7vw;

  }

  .slider-content {
    display: flex;
    transition: transform 0.5s ease;
    height: 100%;
    // left: calc(17vw - 70px);
  }

  .slider-item {
    flex: 0 0 6.6667rem;
    height: 8.8889rem;
    padding: 0;
    box-sizing: border-box;
    margin-right: 0.3333rem;
  }
  .slider-item:last-child {
    margin-right: 0px;
  }

  .card {
    width: 100%;
    height: 100%;
    border-radius: 0.2222rem;
  }

  .nav-button {
    width: 1.1852rem;
    height: 1.1852rem;
    position: absolute;
    z-index: 2;
    cursor: pointer;
    display: none;
  }
  .left {
    left: calc(17vw - 170px);
    top: 50%;
    transform: translateY(-50%);
  }

  .right {
    right: calc(17vw - 170px);
    top: 50%;
    transform: translateY(-50%);
  }
}
//pad768
@media screen and (min-width: 768px) and (max-width: 1439px) {
 .slider-container:hover .nav-button{
    display: block;
  }
  .slider-container {
    display: flex;
    align-items: center;
    // width: 24.7778rem;
    height: 8.9259rem;
    margin: 0 auto;
    // margin-left: auto;
    position: relative;
    width: 100vw;

    .redTag {
      width: 2.6667rem;
      height: 2.6667rem;
      background: #c25e4d;
      border-radius: 0.4444rem 0 0.2222rem 0;
      position: absolute;
      left: -1.3333rem;
      bottom: -0.6667rem;
      left: calc(7vw - 70px);
    }
  }

  .slider-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-left: 7vw;

  }

  .slider-content {
    display: flex;
    transition: transform 0.5s ease;
    height: 100%;
    // left: calc(17vw - 70px);
  }

  .slider-item {
    flex: 0 0 6.6667rem;
    height: 8.8889rem;
    padding: 0;
    box-sizing: border-box;
    margin-right: 0.3333rem;
  }
  .slider-item:last-child {
    margin-right: 0px;
  }

  .card {
    width: 100%;
    height: 100%;
    border-radius: 0.2222rem;
  }

  .nav-button {
    width: 1.1852rem;
    height: 1.1852rem;
    position: absolute;
    z-index: 2;
    cursor: pointer;
    display: none;
  }
  .left {
    left: calc(17vw - 170px);
    top: 50%;
    transform: translateY(-50%);
  }

  .right {
    right: calc(17vw - 170px);
    top: 50%;
    transform: translateY(-50%);
  }
}
//小web1440
@media screen and (min-width: 1440px) and (max-width: 1919px) {
  .slider-container:hover .nav-button{
    display: block;
  }
  .slider-container {
    display: flex;
    align-items: center;
    // width: 24.7778rem;
    height: 8.9259rem;
    margin: 0 auto;
    // margin-left: auto;
    position: relative;
    width: 100vw;

    .redTag {
      width: 2.6667rem;
      height: 2.6667rem;
      background: #c25e4d;
      border-radius: 0.4444rem 0 0.2222rem 0;
      position: absolute;
      left: -1.3333rem;
      bottom: -0.6667rem;
      left: calc(7vw - 70px);
    }
  }

  .slider-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-left: 7vw;

  }

  .slider-content {
    display: flex;
    transition: transform 0.5s ease;
    height: 100%;
    // left: calc(17vw - 70px);
  }

  .slider-item {
    flex: 0 0 6.6667rem;
    height: 8.8889rem;
    padding: 0;
    box-sizing: border-box;
    margin-right: 0.3333rem;
  }
  .slider-item:last-child {
    margin-right: 0px;
  }

  .card {
    width: 100%;
    height: 100%;
    border-radius: 0.2222rem;
  }

  .nav-button {
    width: 1.1852rem;
    height: 1.1852rem;
    position: absolute;
    z-index: 2;
    cursor: pointer;
    display: none;
  }
  .left {
    left: calc(17vw - 170px);
    top: 50%;
    transform: translateY(-50%);
  }

  .right {
    right: calc(17vw - 170px);
    top: 50%;
    transform: translateY(-50%);
  }
}

//大web1920
@media screen and (min-width: 1920px) {
  .slider-container:hover .nav-button{
    display: block;
  }
  .slider-container {
    display: flex;
    align-items: center;
    width: 30.7407rem;
    height: 8.9259rem;
    margin: 0 auto;

    position: relative;
    // background-color: pink;
    width: 100vw;
    // padding-left: 15vw;
    .redTag {
      width: 2.6667rem;
      height: 2.6667rem;
      background: #c25e4d;
      border-radius: 0.4444rem 0 0.2222rem 0;
      position: absolute;
      left: calc(17vw - 70px);
      bottom: -0.6667rem;
    }
  }

  .slider-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;
    padding-left: 17vw;
  }

  .slider-content {
    display: flex;
    transition: transform 0.5s ease;
    height: 100%;
  }

  .slider-item {
    flex: 0 0 6.6667rem;
    height: 8.8889rem;
    padding: 0;
    box-sizing: border-box;
    margin-right: 0.3333rem;
  }
  .slider-item:last-child {
    margin-right: 0px;
  }

  .card {
    width: 100%;
    height: 100%;
    border-radius: 0.2222rem;
  }

  .nav-button {
    width: 1.1852rem;
    height: 1.1852rem;
    position: absolute;
    z-index: 9;
    display: none;
  }
  .left {
    left: calc(17vw - 180px);
    top: 50%;
    transform: translateY(-50%);
  }

  .right {
    right: calc(17vw - 180px);
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>